import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import _ from "underscore";

import type { InputProps } from "Theme/Input";

import makeBem from "Utils/makeBem";

const bem = makeBem("SIFormInput");
/**
 * @deprecated Please import from Theme/Input instead
 * @example import { Input as SIFormInput } from "Theme/Input";
 * */

class SIFormInput extends React.Component<InputProps> {
  maskedInput: MaskedInput | null | undefined;

  static defaultProps = {
    theme: "default",
    mask: false,
    guide: false,
    showMask: false,
    maxLength: "255",
  };

  render() {
    const { className, prependContent, appendContent, theme, meta, input, ...rest } = this.props;
    const hasWrapper = prependContent || appendContent;
    const classes = classnames(bem(), !hasWrapper && className, {
      [bem(null, "prepended")]: !_.isEmpty(prependContent),
      [bem(null, "appended")]: !_.isEmpty(appendContent),
      [bem(null, "intuit")]: isIntuit(),
      [bem(null, `theme-${theme}`)]: theme !== "default",
      [bem(null, "error")]: meta && meta.touched && meta.error,
    });
    const wrapperClasses = classnames("SIFormInput__Wrap", hasWrapper && className);
    const inputElement = <MaskedInput ref={(e) => (this.maskedInput = e)} className={classes} {...input} {...rest} />;

    if (hasWrapper) {
      return (
        <div className={wrapperClasses}>
          {prependContent && <span className={classnames(bem("Span", "prepend"), isIntuit() && bem("Span", "intuit"))}>{prependContent}</span>}
          {inputElement}
          {appendContent && <span className={classnames(bem("Span", "append"), isIntuit() && bem("Span", "intuit"))}>{appendContent}</span>}
        </div>
      );
    }
    return inputElement;
  }
}

SIFormInput.propTypes = {
  prependContent: PropTypes.string,
  appendContent: PropTypes.string,
};
export default SIFormInput;
